import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "nb_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const http = axios.create({ baseURL: API, withCredentials: true });
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
// Se o backend responder 402 (Payment Required = trial acabou), leva pra tela de assinatura.
http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402 && typeof window !== "undefined") {
      if (window.location.pathname !== "/perfil/assinatura") {
        window.location.assign("/perfil/assinatura?expired=1");
      }
    }
    return Promise.reject(err);
  },
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Algo deu errado. Tenta de novo?";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const fileUrl = (id, thumb = false) =>
  id ? `${API}/files/${id}?auth=${getToken()}${thumb ? "&thumb=1" : ""}` : null;
